module.exports = __webpack_public_path__ + "img/line-ux-md.1713b282.svg";